import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AssessmentSyncReport from "./routes/AssessmentSyncReport";

export default store => ({
  path: "dashboard",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([import("./components")]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentSyncReport(store)],
});
